

import { GSCBackingPackage } from "../types";

/**
 * GSC FORMAT SERVICE v1.0
 * Formalisation du conteneur pédagogique .gsc
 */

export const parseGscFile = async (file: File): Promise<GSCBackingPackage> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const json = JSON.parse(e.target?.result as string);
                if (json.format !== "GSC_BACKING_TRACK") {
                    throw new Error("Invalid GSC Format");
                }
                resolve(json as GSCBackingPackage);
            } catch (err) {
                reject(err);
            }
        };
        reader.onerror = () => reject(new Error("File reading failed"));
        reader.readAsText(file);
    });
};

export const createGscFile = (data: GSCBackingPackage): Blob => {
    const jsonString = JSON.stringify(data, null, 2);
    return new Blob([jsonString], { type: "application/json" });
};

export const base64ToBlob = (base64: string, mimeType: string): Blob => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
};

export const blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = (reader.result as string).split(',')[1];
            resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};